export default {
    typeVehicles: [],
    dataVehicle: [],
    showComponentVehicle: false
};



// WEBPACK FOOTER //
// ./src/modules/contact-vehicles/state.js